export interface ClassifyReplyResult {
  label: string;
  confidence: number;
}

export const HIGH_CONFIDENCE = 0.7;
export const MEDIUM_CONFIDENCE = 0.4;

export function formatClassifyReply(results: ClassifyReplyResult[]): string {
  const top = results[0];
  if (!top) return "Je n'ai pas réussi à me faire une idée.";
  const percent = Math.round(top.confidence * 100);
  if (top.confidence >= HIGH_CONFIDENCE) return `Je pense que c'est ${top.label} ! (${percent}% sûr)`;
  if (top.confidence >= MEDIUM_CONFIDENCE) return `Je crois que c'est peut-être ${top.label}... (${percent}% sûr)`;
  return `Hmm, je ne suis pas très sûr, mais je dirais ${top.label} (${percent}%).`;
}
